import { getM8PartnerURL } from 'services/production/utils/getM8URL';
import { HTTPResponseError, UserNotFoundError } from 'utils/errors';
import { customFetch } from 'utils/http';
import { createQueryString } from 'services/production/utils/createQueryString';
import { M8PartnerClientDTO } from 'services/production/types';
import { m8ErrorMessageMap } from 'services/production/utils/constants';

type Params = {
  idClient: number;
};

export const getClientById = async (
  params: Params
): Promise<M8PartnerClientDTO> => {
  const fetchURL = getM8PartnerURL(
    `getClientById?${createQueryString(params)}`
  );

  const response = await customFetch(fetchURL);

  if (!response.ok) {
    if (response.status === 400) {
      const { message } = await response.json();

      if (message === m8ErrorMessageMap.USER_NOT_FOUND) {
        throw new UserNotFoundError();
      }
    }

    throw new HTTPResponseError(response);
  }

  return response.json();
};
